<div class="flex flex-col items-center justify-center text-center px-2 py-4 sm:px-6 sm:py-8 gap-5">
  <div
    class="flex items-center justify-center w-20 h-20 rounded-full bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400"
    aria-hidden="true"
  >
    <i class="pi pi-cog !text-4xl"></i>
  </div>

  <div class="space-y-2 max-w-md">
    <h2 class="text-xl sm:text-2xl font-semibold text-gray-900 dark:text-gray-100">
      {{ 'firstConfiguration.title' | translate }}
    </h2>
    <p class="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
      {{ 'firstConfiguration.description' | translate }}
    </p>
  </div>

  <p-button
    [label]="'firstConfiguration.goToConfiguration' | translate"
    icon="pi pi-arrow-right"
    iconPos="right"
    (onClick)="goToConfiguration()"
    styleClass="!rounded-full !px-6"
  />
</div>
